import React, { FunctionComponent, useCallback } from 'react';

import cn from 'classnames';

import Button from '../../../../shared/components/button';
import SvgImage from '../../../../shared/components/svg-image';
import { i18n } from '../../../../shared/helpers/i18n';
import { countMetrika } from '../../../../shared/helpers/metrika';
import { useActions } from '../../../../shared/hooks';
import { unshareScreenAction } from '../../features/screen-sharing/slice';
import { ParticipantSharingPreloader } from '../participant-sharing-preloader';
import css from './self-screen-sharing-stub.css';

const shareScreenIcon = <SvgImage imageName="shareScreen" className={css.shareScreenIcon} />;

export const SelfScreenSharingStubLoader: FunctionComponent = () => {
    const actions = useActions({ unshareScreenAction });

    const onStopSharing = useCallback(() => {
        actions.unshareScreenAction(undefined);
        countMetrika('meeting_screen', 'stop_sharing_in_center');
    }, [actions]);

    return (
        <div className={cn(css.container, 'selfScreenSharingLoader')}>
            <ParticipantSharingPreloader className={css.loader} isSelf={true} />
            <Button className={css.button} view="neutral" size="lg" iconLeft={shareScreenIcon} onClick={onStopSharing}>
                {i18n('share-screen', 'stop-demonstration-2')}
            </Button>
        </div>
    );
};
